const camelize = function (str) {
    return str.replace(/-(\w)/g, (str, letter) => {
        return letter.toUpperCase();
    });
};

function getComputedCss(el, styleProp) {
    if (!el) {
        return '';
    }
    if (el.currentStyle) {
        return el.currentStyle[camelize(styleProp)];
    } else if (document.defaultView && document.defaultView.getComputedStyle) {
        return document.defaultView
            .getComputedStyle(el, null)
            .getPropertyValue(styleProp);
    } else {
        return el.style[camelize(styleProp)];
    }
}

export default getComputedCss;